import { isMobileDevice } from '../../../utils/window-utils';

export function jumpToSection(targetedElementId: string) {
  const targettedElement = document.getElementById(targetedElementId);
  if (!targettedElement)
    return;
 
  const header = document.querySelector(".root .sticky-wrapper");
  const headerHeight = Math.round(header?.getBoundingClientRect().height ?? 0);
  const stickyHeader = document.querySelector(".root .sticky-header");
  const fundTitleMobile = document.querySelector('.fund-title-wrapper-mobile .fund-title');
  const fundTitleMobileHeight = Math.round(fundTitleMobile?.getBoundingClientRect().height ?? 0);
  const fundLabel = stickyHeader?.querySelector('.inner-container-mobile .fund-label');
  const fundLabelHeight = Math.round(fundLabel?.getBoundingClientRect().height ?? 0);
  const targetElementTop = targettedElement.getBoundingClientRect().top + document.documentElement.scrollTop;

  const mobileOffset = isMobileDevice()
  ? (fundLabelHeight ? fundLabelHeight : fundTitleMobileHeight - 5)
  : 30;

  window.scrollTo({
    behavior: "auto",
    top: targetElementTop - headerHeight - mobileOffset  - 65,
  });
}
